export const ACTIONS = {
  STUDENT_TALK_TIME_UPDATED: 'STUDENT_TALK_TIME_UPDATED',
  TEACHER_TALK_TIME_UPDTAED: 'TEACHER_TALK_TIME_UPDTAED',
  UPDATE_BATCH_SEEN: 'UPDATE_BATCH_SEEN',
  CAN_DISPLAY_TM: 'CAN_DISPLAY_TM',
} as const;

export interface UpdateStudentTalkTime<
  P = {
    teacher_classroom_id: string;
    student_classroom_id: string;
    student_speech_time: number;
    speech_end: number;
    speech_start: number;
  },
> {
  (payload: P): {
    type: typeof ACTIONS.STUDENT_TALK_TIME_UPDATED;
    payload: P;
  };
}

export const updateStudentTalkTime: UpdateStudentTalkTime = payload => ({
  type: ACTIONS.STUDENT_TALK_TIME_UPDATED,
  payload,
});

export interface UpdateTeacherTalkTime<
  P = {
    teacher_classroom_id: string;
    student_classroom_id: string;
    teacher_speech_time?: number;
    student_speech_time?: number;
    batch_no: number;
  },
> {
  (payload: P): {
    type: typeof ACTIONS.TEACHER_TALK_TIME_UPDTAED;
    payload: P;
  };
}

export const updateTeacherTalkTime: UpdateTeacherTalkTime = payload => ({
  type: ACTIONS.TEACHER_TALK_TIME_UPDTAED,
  payload,
});

export interface UpdateBatchSeen<
  P = {
    teacher_classroom_id: string;
    batch_no: number;
  },
> {
  (payload: P): {
    type: typeof ACTIONS.UPDATE_BATCH_SEEN;
    payload: P;
  };
}

interface CanDisplayTM<
  P = {
    teacher_classroom_id: string;
    canDisplay: boolean;
  },
> {
  (payload: P): {
    type: typeof ACTIONS.CAN_DISPLAY_TM;
    payload: P;
  };
}

export const canDisplayTalkMeter: CanDisplayTM = payload => ({
  type: ACTIONS.CAN_DISPLAY_TM,
  payload,
});
